import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/common_staking.jpg'
import _imports_1 from '@/assets/rarity_staking.jpg'
import _imports_2 from '@/assets/upgraded_staking.jpeg'
import _imports_3 from '@/assets/closed.png'
import _imports_4 from '@/assets/live.png'


const _withScopeId = n => (_pushScopeId("data-v-1a53ce53"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row col-8 m-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-line" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "card-title home-title" }, "STAKING")
], -1))
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_9 = { class: "row col-8 m-auto" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-line" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "card-title home-title" }, "MISSIONS")
], -1))
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "ts",
          to: "common"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "ts",
          to: "rarity"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          class: "ts",
          to: "upgraded"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_router_link, {
          class: "ts",
          to: "mission"
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_router_link, {
          class: "ts",
          to: "mission-uncommon"
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}